var _defs, _rect, _text, _g, _line, _line2, _line3, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSequentialApproval(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 520 120",
    role: "img",
    "aria-label": "Sequential approval routing",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "seqBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ecfeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f8fafc"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "seqArrow",
    markerWidth: 8,
    markerHeight: 8,
    refX: 7,
    refY: 4,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,4 L0,8 Z",
    fill: "#0891b2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 120,
    rx: 8,
    fill: "url(#seqBg)",
    stroke: "#a5f3fc"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 18,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fontWeight: 600,
    fill: "#0e7490"
  }, "Sequential routing")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    fill: "#0f172a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 42,
    width: 72,
    height: 36,
    rx: 6,
    fill: "#fff",
    stroke: "#94a3b8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 64,
    textAnchor: "middle"
  }, "Submit"), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 42,
    width: 88,
    height: 36,
    rx: 6,
    fill: "#fff",
    stroke: "#0891b2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 58,
    textAnchor: "middle"
  }, "Stage 1"), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 70,
    textAnchor: "middle",
    fontSize: 8,
    fill: "#64748b"
  }, "Line Mgr"), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 42,
    width: 88,
    height: 36,
    rx: 6,
    fill: "#fff",
    stroke: "#0891b2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 58,
    textAnchor: "middle"
  }, "Stage 2"), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 70,
    textAnchor: "middle",
    fontSize: 8,
    fill: "#64748b"
  }, "HR / Group"), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 42,
    width: 88,
    height: 36,
    rx: 6,
    fill: "#cffafe",
    stroke: "#0891b2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 428,
    y: 64,
    textAnchor: "middle"
  }, "Complete"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 60,
    x2: 124,
    y2: 60,
    stroke: "#0891b2",
    strokeWidth: 2,
    markerEnd: "url(#seqArrow)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 216,
    y1: 60,
    x2: 252,
    y2: 60,
    stroke: "#0891b2",
    strokeWidth: 2,
    markerEnd: "url(#seqArrow)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 344,
    y1: 60,
    x2: 380,
    y2: 60,
    stroke: "#0891b2",
    strokeWidth: 2,
    markerEnd: "url(#seqArrow)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 102,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    fill: "#64748b"
  }, "Each stage must finish before the next starts")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequentialApproval);
export default __webpack_public_path__ + "static/media/sequential-approval.569df6585d6bc78528790d34126689b6.svg";
export { ForwardRef as ReactComponent };